import { scaleLinear } from 'd3-scale'
import { normalizeAngle } from './angleOpetations'

export const colors = {
  v1: {
    red: '#e12d2d',
    yellow: '#f9d737',
    green: '#7eb144',
    blue: '#159fcf',
    magenta: '#5d35af',
    pink: '#9d1f8f',
  },
  v2: {
    red: '#ff542e',
    yellow: '#ffb300',
    green: '#76d89a',
    blue: '#1ad2f2',
    magenta: '#7171fe',
    pink: '#d34a9d',
  },
}

const colorScale = scaleLinear<string>()
  .domain([0, 90, 150, 210, 270, 315, 360])
  .range([
    colors.v2.red,
    colors.v2.yellow,
    colors.v2.green,
    colors.v2.blue,
    colors.v2.magenta,
    colors.v2.pink,
    colors.v2.red,
  ]) // wrap some colors around to simulate the wrap around of the color wheel - 0 = 360

export default function angleToColor(angle: number) {
  return colorScale(normalizeAngle(angle))
}
